// modules/NotFound.js
import React from 'react';

class NotFound extends React.Component {
	render() {
		return (
			<div className="App">
				<div className="App-header">
					<h2>No information available</h2>
				</div>
			</div>
		);
	}
}

export default NotFound;


/** WEBPACK FOOTER **
 ** ./src/modules/NotFound.js
 **/